import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Shield, AlertCircle, Settings } from "lucide-react";
import { Layout } from "../../Components/layout";
import { Alert, Button, Col, Row, Spinner } from "react-bootstrap";

export function BiometriaGeolocalizacao() {
  const [loading, setLoading] = useState(false);
  const [permissionStatus, setPermissionStatus] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const requestLocation = () => {
    setLoading(true);
    setError(null);

    if (permissionStatus === "denied") {
      setLoading(false);
      setError(
        "Localização bloqueada. Você precisa permitir o acesso nas configurações do navegador (ícone de cadeado/ajustes na barra de endereço).",
      );
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        localStorage.setItem(
          "@flexgr-validacao-facial:coordenadas",
          JSON.stringify({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }),
        );

        setLoading(false);
        navigate("/biometria/termos");
      },
      (geoError) => {
        setLoading(false);
        if (geoError.code === 1) {
          setError("Acesso negado. Habilite a localização para prosseguir.");
        } else if (geoError.code === 3) {
          setError(
            "Tempo esgotado. Verifique se o seu GPS está ligado e tente novamente.",
          );
        } else {
          setError(
            "Não foi possível obter sua localização. Tente novamente em alguns instantes.",
          );
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      },
    );
  };

  useEffect(() => {
    if ("permissions" in navigator) {
      navigator.permissions.query({ name: "geolocation" }).then((result) => {
        setPermissionStatus(result.state);

        result.onchange = () => setPermissionStatus(result.state);
      });
    }
  }, []);

  return (
    <Layout>
      <Row className="m-0 d-flex flex-column align-items-center justify-content-center">
        <Alert
          variant={error ? "danger" : "primary"}
          className={`icon_container p-2 mb-4 ${error ? "border-danger" : ""}`}
        >
          {error ? (
            <AlertCircle className="icon_style text-danger" />
          ) : (
            <MapPin className="icon_style" />
          )}
        </Alert>

        <Col className="p-0 text-center mb-3">
          <h1 className="title">
            {error ? "Permissão Negada" : "Ativar Localização"}
          </h1>

          <p className="subtitle">
            {error
              ? error
              : "Para prosseguir com a biometria facial, habilite a geolocalização do seu celular."}
          </p>
        </Col>

        {error && (
          <Alert
            variant="warning"
            className="my-4 p-4 card_info border-warning small text-left"
          >
            <p className="mb-1 d-flex align-items-center gap-2 font-bold">
              <Settings className="icon_style_sm" /> Como habilitar:
            </p>
            <ol className="ms-2">
              <li>
                Toque no ícone de <strong>ajustes/cadeado</strong> ao lado da
                URL (topo da tela).
              </li>
              <li>
                Encontre a opção <strong>Localização</strong> ou{" "}
                <strong>Permissões</strong>.
              </li>
              <li>
                Altere para <strong>Permitir</strong> e atualize a página.
              </li>
            </ol>
          </Alert>
        )}

        <Col className="p-0 d-flex flex-column gap-3">
          {error ? (
            <Button
              onClick={requestLocation}
              className="w-100 py-2 d-flex align-items-center justify-content-center gap-2"
              size="lg"
              style={{ fontSize: "1.1rem" }}
            >
              <Settings className="h-5 w-5" />
              Tentar Novamente
            </Button>
          ) : (
            <Button
              onClick={requestLocation}
              disabled={loading}
              className="w-100 py-2 d-flex align-items-center justify-content-center gap-2"
              size="lg"
            >
              {loading ? (
                <Spinner role="status" animation="border" size="sm" />
              ) : null}
              {loading ? "Aguardando permissão..." : "Ativar Localização"}
            </Button>
          )}

          <Button
            onClick={() => navigate("/biometria/cancelar")}
            variant="danger"
            className="w-100 py-2 d-flex align-items-center justify-content-center gap-2"
            size="lg"
          >
            {error ? "Sair" : "Cancelar e Sair"}
          </Button>
        </Col>

        <Col
          className="p-0 mt-4 d-flex align-items-center justify-content-center gap-2 small"
          style={{ color: "var(--text-muted)" }}
        >
          <Shield className="h-3.5 w-3.5" />
          Ambiente Seguro Flex Consulta
        </Col>
      </Row>
    </Layout>
  );
}
